import React from "react";
import Grid from "@material-ui/core/Grid";
import Comma from "../../../../assets/images/comma.png";
class BlackButton extends React.Component{
    constructor() {
        super();
    }
    render() {
        const {backgroundColor,textColor,text,bottomFontSize,icon,borderColor}=this.props.data
        return(
            <Grid className='button' item container justify={"center"} alignItems={"center"}  style={{borderColor: borderColor?borderColor:'',backgroundColor:backgroundColor,width:'100%',overflow:'visible'}}>
                <Grid className='button-line'>
                </Grid>
                <img src={Comma} className='button-comma' style={{backgroundColor:'rgba(0.0.0.0.2)'}} alt=""/>
                <img src={icon} className='black-button-icon' style={{backgroundColor:'rgba(0.0.0.0.2)'}} alt=""/>
                <Grid className='button-background'/>
                <p style={{fontSize:bottomFontSize,color:textColor,position:'absolute'}}>
                    {text}
                </p>
            </Grid>
        )
    }
}
export default BlackButton